// Helpers for the FileAsset backend model.
// Original files are private and downloaded through authenticated feature endpoints.
// Image thumbnails come back as relative preview paths (e.g. /file-previews/x.jpg)
// that need the base host prefixed for display.

const BASE = (process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '')

// Resolve a backend thumbnail/preview path to a full, displayable URL. Null-safe:
// returns null when there is no thumbnail (caller should show a placeholder/icon).
export const thumbUrl = (path) => {
  if (!path) return null
  if (/^https?:\/\//i.test(path)) return path
  return `${BASE}/${String(path).replace(/^\//, '')}`
}

export default thumbUrl
